const DEFAULT_SUCCESS_DESTINATION = 'https://www.google.com/';

export function successDestination(value?: string): string {
  if (!value) return DEFAULT_SUCCESS_DESTINATION;
  try {
    const destination = new URL(value);
    return destination.protocol === 'https:' ? destination.toString() : DEFAULT_SUCCESS_DESTINATION;
  } catch {
    return DEFAULT_SUCCESS_DESTINATION;
  }
}
